import ShippingPreferences from "./ShippingPreferences";
export default ShippingPreferences;
